import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '爆料分类',
    links: [
      { label: '网红塌房', path: '/category/influencer-scandal' },
      { label: '明星黑料', path: '/category/celebrity-scandal' },
      { label: '博主反差', path: '/category/blogger-contrast' },
      { label: '网曝门事件', path: '/category/exposure-gate' },
    ],
  },
  {
    title: '快速导航',
    links: [
      { label: '每日大赛', path: '/category/daily-contest' },
      { label: '视频入口', path: '/category/video-entry' },
      { label: '关于我们', path: '/about' },
      { label: '返回首页', path: '/' },
    ],
  },
  {
    title: '联系方式',
    links: [
      { label: '商务合作', path: '/about#contact' },
      { label: '侵权申诉', path: '/about#contact' },
      { label: '投稿爆料', path: '/about#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            {/* Brand */}
            <div className="lg:col-span-1">
              <Link to="/" className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
                  <i className="ri-fire-line text-background-50 text-xl"></i>
                </div>
                <span className="font-heading text-2xl font-bold">51吃瓜黑料</span>
              </Link>
              <p className="text-foreground-300 text-sm leading-relaxed mb-5">
                全网最全吃瓜平台，覆盖网红塌房、明星爆料、博主反差等热点资讯。网站不打烊，吃瓜不停歇。
              </p>
              <div className="flex items-center gap-3">
                {['ri-weibo-line', 'ri-wechat-line', 'ri-tiktok-line', 'ri-bilibili-line'].map((icon) => (
                  <a
                    key={icon}
                    href="#"
                    className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors duration-200"
                    rel="nofollow"
                    aria-label="社交链接"
                  >
                    <i className={`${icon} text-sm`}></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Link Groups */}
            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="font-label text-xs uppercase tracking-wider text-foreground-400 mb-5 font-semibold">
                  {group.title}
                </h4>
                <ul className="flex flex-col gap-3">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-foreground-300 hover:text-background-50 text-sm transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Bottom */}
          <div className="border-t border-foreground-800 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-xs">
              &copy; {new Date().getFullYear()} 51吃瓜黑料 版权所有 | 本站内容仅供娱乐参考
            </p>
            <div className="flex items-center gap-5">
              <Link to="/" className="text-foreground-500 hover:text-background-50 text-xs transition-colors">
                首页
              </Link>
              <Link to="/about" className="text-foreground-500 hover:text-background-50 text-xs transition-colors">
                关于我们
              </Link>
              <Link to="/about#contact" className="text-foreground-500 hover:text-background-50 text-xs transition-colors">
                联系我们
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}